import { useState } from 'react';
import { IAsset } from '../../../../Interfaces/Asset/IAsset';
import { IConfig } from '../../../../Interfaces/IConfig';
import { IDocument } from '../../../../Interfaces/IDocument';
import {
  getEmptyInheritanceRelationshipData,
  IInheritanceRelationshipData,
} from '../../../../Interfaces/IInheritanceRelationshipData';
import { ILegalTransactionRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { DialogFrame } from '../../../core/DialogFrame';
import {
  useDialogContext,
  withDialogProvider,
} from '../../../core/DialogPresenter/DialogContext';
import { useLegalClientStore } from '../generic/legalClientStore';
import { ISavedRelationshipDialogData } from '../generic/utilities';
import { RestoreProgress } from '../RestoreProgress';
import { SaveProgress } from '../SaveProgress';
import { TestamentAssets } from './slides/TestamentAssets';
import { TestamentMainTestator } from './slides/TestamentMainTestator';
import { TestamentRelatives } from './slides/TestamentRelatives';
import { TestamentSecondaryTestator } from './slides/TestamentSecondaryTestator';
import { TestamentSend } from './slides/TestamentSend';
import { TestamentStart } from './slides/TestamentStart';
import { TestamentSummary } from './slides/TestamentSummary';
import { TestamentUploadTestaments } from './slides/TestamentUploadTestament';

interface ITestamentDialogProps {
  configObject: IConfig;
}

type ISavedTestamentData =
  ISavedRelationshipDialogData<IInheritanceRelationshipData> & {
    assets: IAsset[];
  };

const TestamentDialog: React.FC<ITestamentDialogProps> = ({ configObject }) => {
  const { goToPage } = useDialogContext();
  const [legalClientArray, putLegalClient] = useLegalClientStore(state => [
    state.legalClientArray,
    state.putLegalClient,
  ]);
  const [assetArray, setAssetArray] = useState<IAsset[]>([]);
  const [documentArray, setDocumentArray] = useState<IDocument[]>([]);
  const [testamentData, setTestamentData] = useState(
    getEmptyInheritanceRelationshipData()
  );
  const [relationshipArray, setRelationshipArray] = useState(
    [] as ILegalTransactionRelationship[]
  );

  const restoreSetterFunction = (savedData: ISavedTestamentData) => {
    const { relationshipArray, legalClientArray, data } = savedData;
    setRelationshipArray(relationshipArray);
    legalClientArray.forEach(putLegalClient);

    setTestamentData(data);
    setAssetArray(savedData.assets);
    goToPage(0);
  };
  const dataToSave = (): ISavedTestamentData => {
    return {
      relationshipArray,
      legalClientArray,
      data: testamentData,
      assets: assetArray,
    };
  };

  return (
    <DialogFrame
      configObject={configObject}
      title={'Formular zum Testament'}
      headerButtonArray={[
        <RestoreProgress
          key='testament-import'
          setterFunction={restoreSetterFunction}
        ></RestoreProgress>,
        <SaveProgress
          key='testament-export'
          idLegaltransaction={1}
          getDataToSave={dataToSave}
          filename={'Testament Notarvorgang'}
        ></SaveProgress>,
      ]}
      txt={''}
    >
      <TestamentStart />
      <TestamentUploadTestaments
        documents={documentArray}
        setDocuments={setDocumentArray}
      />
      <TestamentMainTestator
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentSecondaryTestator
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentRelatives
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentAssets
        configObject={configObject}
        assetArray={assetArray}
        setAssetArray={setAssetArray}
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
      />
      <TestamentSummary
        configObject={configObject}
        assetArray={assetArray}
        relationshipArray={relationshipArray}
        setRelationshipArray={setRelationshipArray}
        documentArray={documentArray}
      />
      <TestamentSend />
    </DialogFrame>
  );
};

export default withDialogProvider(TestamentDialog);
